export const labelsZh = {
  // 页面标题
  title: '标签管理',
  
  // 操作
  generateLabels: '生成标签',
  generate: '生成',
  print: '打印',
  downloadLabel: '下载标签',
  printSuccess: '打印成功',
  
  // 模板类型
  template: '模板',
  compact: '紧凑',
  standard: '标准',
  detailed: '详细',
  
  // 设置
  size: '尺寸',
  printCount: '打印数量',
  selectPrinter: '选择打印机',
  
  // 状态
  selected: '已选择',
};

export type LabelsTranslations = typeof labelsZh;

